// src/Pages/HomePage.js

import './HomePage.css';
import Header from '../Assets/Components/Header.js';
import Banner from '../Assets/Components/Banner.js';
import Footer from '../Assets/Components/Footer.js';
import Splash from '../Assets/Components/Splash.js';
import Projects from '../Assets/Components/Projects.js';


const HomePage = () => {
    return (
        <div className='homepage'>
            <Header />
            <div className='main-content'>
                <Banner />
                <Splash />
                <Projects />
            </div>
            <Footer />
        </div>
    );
};

export default HomePage;